import { render, staticRenderFns } from "./AddTransSideBar.vue?vue&type=template&id=1ded54d5&"
import script from "./AddTransSideBar.vue?vue&type=script&lang=js&"
export * from "./AddTransSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports